/* eslint-disable no-console */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-lonely-if */
import $ from 'jquery';
import { anionsProp, cationsProp, localstorageVal, controlsButtonTitle, fatalMarkersData, warningMarkerData } from './constantVariable';

export const getEmailUserType = (userEmail) => {
  let emailType = 'internal';
  if (userEmail) {
    emailType = userEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  }
  return emailType;
};
export const decimalFormatter = (value, decimal) => {
  const number = value ? Number(value).toFixed(decimal) : 0;
  return number;
};

export const floatFormat = (value) => {
  const floatNumber = value ? parseFloat(value) : 0;
  return floatNumber;
};

export const isObjectEmpty = (obj) => {  // retun true if key value presnet & return false if obj is empty {}
  if (!obj) return false;
  return Object.getOwnPropertyNames(obj).length >= 1;
};
export const checkLocalStorageValue = (key) => {
  const value = localStorage.getItem(key);
  if (value !== null && value !== undefined && value !== '') {
    return true; // Key has a value
  }
  return false; // Key does not have a value

};

export const getStyles = (name, personName, theme) => {
  return {
    fontWeight:
      personName === name
        ? theme.typography.fontWeightBold
        : theme.typography.fontWeightMedium,
  };
};

export const getSumValues = (arr, ittr) => {
  if (!arr.length) return {};
  const sumArr = arr.filter((val) => val.Ion !== 'CO2');
  return sumArr.reduce((total, currentValue) => {
    return {
      Ion: ittr,
      MgL: Number((Number(total.MgL) + Number(currentValue.MgL)).toFixed(3)),
      Meq: Number((Number(total.Meq) + Number(currentValue.Meq)).toFixed(4)),
      ppmAsCaCO3: Number((Number(total.ppmAsCaCO3) + Number(currentValue.ppmAsCaCO3)).toFixed(2)),
    };
  });
};

export const toFixedNumber = (value, fixedValue) => {
  if (!value) return 0;
  return Number(value).toFixed(fixedValue);
};

export const getMassAndCharge = (obj) => {
  if (!isObjectEmpty(obj)) return {};
  const data = [...cationsProp, ...anionsProp].find(
    (val) => val.Ion === obj.Ion
  );
  return data;
};

export const calculateCompositions = (value, mass, charge) => {
  const meq = charge > 0 ? value.MgL / (mass / charge) : value.MgL / mass;
  const ppmAsCaCO3 =
    charge > 0
      ? (value.MgL * 50.0435) / (mass / charge)
      : (value.MgL * 50.0435) / mass;
  return { MgL: Number((value.MgL).toFixed(3)), Meq: Number(meq.toFixed(4)) || 0, ppmAsCaCO3: Number(ppmAsCaCO3.toFixed(2)) || 0 };
};

export const getSumValuesOfIon = (arr1, arr2) => {
  return {
    updatedCat: arr1.map((val) => {
      const { mass, charge } = getMassAndCharge(val);
      const absCharge = Math.abs(charge);
      const { MgL, Meq, ppmAsCaCO3 } = calculateCompositions(
        val,
        mass,
        absCharge
      );
      val.MgL = Number(MgL.toFixed(3)); // abhishek new
      val.Meq = Number(Meq.toFixed(4));
      val.ppmAsCaCO3 = Number(ppmAsCaCO3.toFixed(2));
      return val;
    }),
    updatedAn: arr2.map((val) => {
      const { mass, charge } = getMassAndCharge(val);
      const absCharge = Math.abs(charge);
      const { MgL, Meq, ppmAsCaCO3 } = calculateCompositions(
        val,
        mass,
        absCharge
      );
      val.MgL = Number(MgL.toFixed(3));
      val.Meq = Number(Meq.toFixed(4));
      val.ppmAsCaCO3 = Number(ppmAsCaCO3.toFixed(2));
      return val;
    }),
  };
};
// Numbers used in canCellBeEditable functions are the Row Number as i
// and Column Number as j of the Feed Form. It enables & Disables input fields based
// on this parent cell id's
export const canCellBeEditable = (inputMode, chargeBalanceIon) => {
  // let trueOrFalse = false;
  // const {
  //   context: { inputMode, chargeBalanceIon },
  // } = params;
  let cell = [];
  if (chargeBalanceIon) {
    const remove = [
      { i: 20, j: 2 }, { i: 20, j: 3 }, { i: 20, j: 4 },
      { i: 21, j: 2 }, { i: 22, j: 3 }, { i: 22, j: 4 }, { i: 22, j: 2 }
    ];
    remove.map((cell) => {
      $(`.custom-ag-grid .cell_${cell.i}_${cell.j} input`).attr('disabled', null);
    });
  } else if (inputMode === 'co2_hco3') {
    cell = [{ i: 22, j: 2 }, { i: 22, j: 3 }, { i: 22, j: 4 }];
    const remove = [{ i: 20, j: 2 }, { i: 20, j: 3 }, { i: 20, j: 4 }, { i: 21, j: 2 }];
    remove.map((cell) => {
      $(`.custom-ag-grid .cell_${cell.i}_${cell.j} input`).attr('disabled', null);
    });
  } else if (inputMode === 'ph_hco3') {
    const remove = [{ i: 20, j: 2 }, { i: 20, j: 3 }, { i: 20, j: 4 }];
    cell = [{ i: 22, j: 2 }, { i: 22, j: 3 }, { i: 22, j: 4 }, { i: 21, j: 2 }, { i: 21, j: 3 }, { i: 21, j: 4 }];
    remove.map((cell) => {
      $(`.custom-ag-grid .cell_${cell.i}_${cell.j} input`).attr('disabled', null);
    });
  } else {
    cell = [
      { i: 5, j: 3 }, { i: 5, j: 4 }, { i: 17, j: 3 }, { i: 17, j: 4 }, { i: 18, j: 3 }, { i: 18, j: 4 },
      { i: 13, j: 3 }, { i: 13, j: 4 }, { i: 16, j: 3 }, { i: 16, j: 4 }, { i: 19, j: 3 }, { i: 19, j: 4 },
      { i: 20, j: 2 }, { i: 20, j: 3 }, { i: 20, j: 4 },
      { i: 21, j: 2 }, { i: 21, j: 3 }, { i: 21, j: 4 }, { i: 22, j: 2 }, { i: 22, j: 3 }, { i: 22, j: 4 }
    ];
  }
  // if (cell !== []) {
  if (cell && cell.length > 0) {
    cell.map((cell) => {
      $(`.custom-ag-grid .cell_${cell.i}_${cell.j} input`).attr('disabled', 'true');
    });
  }

  // const foundObj = nonEditableCells.find((val) => val.rowId === Ion) || {};
  // if (isObjectEmpty(foundObj)) {
  //   const { colId } = foundObj;
  //   const result = colId === 'all' ? false : !colId.includes(field);
  //   trueOrFalse = result;
  // } else {
  //   trueOrFalse = true;
  // }
  // return trueOrFalse;
};

export const getCellStyle = (params) => {
  let styleObj = {
    'textOverflow': 'ellipsis',
    'whiteSpace': 'nowrap',
    'overflow': 'hidden',
    'display': 'block'
  };
  if (
    !canCellBeEditable(params) &&
    !['Total Anions', 'Total Cations'].includes(params.data.Ion)
  ) {
    styleObj = { ...styleObj, cursor: 'not-allowed', color: '#00000061' };
  }
  return styleObj;
};

export const getCalculatedRows = (cationsRow, anionsRow) => {
  const rows = [
    ...cationsRow,
    getSumValues(cationsRow, 'Total Cations'),
    ...anionsRow,
    getSumValues(anionsRow, 'Total Anions'),
  ];
  return rows;
};

export const tempratureToFarenHeight = (value) => {
  return value * 1.8 + 32;
};

export const fahrenheitToTemperature = (value) => {
  return (value - 32) * (5 / 9);
};

export const getTotal = (obj) => {
  const total = Object.values(obj).reduce(
    (acc, val) => Number(acc) + Number(val)
  );
  return Number(total);
};

export const getSumValuesForProp = (arr, prop) => {
  if (!arr.length) return 0.0;
  const sumArr = arr.filter((val) => val.Ion !== 'CO2');
  return sumArr.reduce((total, currentValue) => {
    return prop === 'MgL' ?
      Number(Number(total) + Number(currentValue[prop])).toFixed(3) :  // 3 decimal place for mg/l by Abhi
      Number(Number(total) + Number(currentValue[prop])).toFixed(2);
  }, 0);
};

export const getSumValuesForPropTemp = (arr, prop) => {
  if (!arr.length) return 0.0;
  const sumArr = arr.filter((val) => val.Ion !== 'CO2');
  return sumArr.reduce((total, currentValue) => {
    return Number(Number(total) + Number(currentValue[prop]));
  }, 0);
};

// drag drop unitop value get unique by shekhar 16-02-2023
export const checkExitsLocalStorageValue = (unitopCurrentId) => {
  const storeKey = Object.keys(localStorage).filter((data) => {
    return data.indexOf(unitopCurrentId) === 0;
  });
  let count = 1;
  if (storeKey.length) {
    const dataArr = [];
    storeKey.forEach((data) => {
      let val = localStorage.getItem(data);
      val = val.split('_');
      if (val.length > 1) {
        val = val[val.length - 1];
      }
      dataArr.push(val);
    });
    for (let i = 0; i < dataArr.length; i += 1) {
      const val = count.toString();
      if (dataArr.indexOf(val) < 0) {
        break;
      }
      count += 1;
    }
    return count;
  }
  return count;
};

// remove unwanted localstorage data and blank storage
export const removeLocalStorageValue = (str) => {
  const localStorageData = Object.keys(localStorage);
  if (localStorageData.length) {
    localStorageData.forEach((data) => {
      const value = localStorage.getItem(data).trim();
      const dataVal = ['', 'null', 'undefined', '{}'];
      if (str === 'removeValue') {
        if (dataVal.indexOf(value) >= 0) {
          localStorage.removeItem(data);
        }
      } else {
        /**
        * check localstorage value is '', null, undefined, {}
        * remove the value in localstorage
        */
        if (dataVal.indexOf(value) >= 0) {
          localStorage.removeItem(data);
        } else {
          /**
          * check localstorage if any key contains `_`
          * exits only one _ in the key
          * second value is number then value is deleted
          * like Feed_1, cls_2, Feed_2
          */
          const val = data.split('_');
          if (val.length === 2 && Number(val[1])) {
            const splitData = `${val[0]}_`;
            if (localstorageVal.indexOf(splitData) >= 0) {
              localStorage.removeItem(data);
            }
          }
        }
      }
    });
  }
  return false;
};
// unitop duplicate value not accepted.
export const checkDuplicateValue = (currentValue, id) => {
  const localStorageData = Object.keys(localStorage);
  let dataFlag = false;
  if (localStorageData.length) {
    localStorageData.forEach((data) => {
      if (data !== id) {
        const splitData = data.slice(0, data.lastIndexOf('_') + 1);
        // const splitData = `${data.split('_')[0]}_`;
        if (localstorageVal.indexOf(splitData) >= 0) {
          if (localStorage.getItem(data).trim() === currentValue) {
            dataFlag = true;
          }
        }
      }
    });
  }
  return dataFlag;
};

// find duplicate value in unitop
export const findDuplicate = (arry) => {
  const toFindDuplicates = (arry) => arry.filter((item, index) => arry.indexOf(item) !== index);
  const duplicateElementa = toFindDuplicates(arry);
  return duplicateElementa;
};
export const findDuplicateData = () => {
  const localStorageData = Object.keys(localStorage);
  if (localStorageData.length) {
    const duplicateUnitopName = [];
    localStorageData.forEach((data) => {
      const splitData = data.slice(0, data.lastIndexOf('_') + 1);
      // const splitData = `${data.split('_')[0]}_`;
      if (localstorageVal.indexOf(splitData) >= 0) {
        const val = localStorage.getItem(data);
        duplicateUnitopName.push(val);
      }
    });
    return findDuplicate(duplicateUnitopName);
  }
};

// remove unwanted charector in array err_list Start

export const cleanMessage = (raw) => {
  return raw
    .replace(/\\r/g, '')                 // Remove escaped carriage returns
    .replace(/[“”]/g, '')                // Remove all curly quotes
    .replace(/\\n/g, '\n')               // Convert escaped newlines to actual line breaks
    .replace(/\\"/g, '')                 // Remove escaped double quotes
    .replace(/"\s*\+\s*/g, '')           // Remove "+ inside quotes
    .replace(/\s*\+\s*/g, '')            // Remove standalone + signs
    .replace(/""/g, '')                  // Remove double quotes
    .replace(/"/g, '')                   // Remove remaining quotes
    .replace(/\\+/g, '')                 // Remove stray backslashes
    // .replace(/\n{2,}/g, '\n')            // Collapse multiple newlines
    .trim();                             // Trim leading/trailing whitespace
};
// remove unwanted charector in array err_list End

/* ######################### Error Data for Unitop ######################### */
export const getErrorHelperData = (obj) => {
  const errorListData = [];
  let errorFlag = false;
  let warningFlag = false;
  let flagError = 'no-error';
  const data = Object.keys(obj);
  const fatalMarkers = fatalMarkersData;
  const warningMarker = warningMarkerData;
  data.forEach((ele) => {
    const k = { ...obj[ele].output_user };
    if (Object.keys(k).length && k.err_list && k.err_list.length > 0) {
      errorListData.push({
        name: ele,
        data: k.err_list
      });
      k.err_list.map((errlist) => {
        if (warningMarker.some(marker => errlist.includes(marker))) {
          warningFlag = true;
        } else if (fatalMarkers.some(marker => errlist.includes(marker))) {
          errorFlag = true;
        }
      });
      // k.err_list.map((errlist) => {
      //   if (errlist.toLowerCase().indexOf('warning') === 0) {
      //     warningFlag = true;
      //   } else if (errlist.toLowerCase().indexOf('fatal error') === 0) {
      //     errorFlag = true;
      //   }
      // });
    }
  });
  if ((warningFlag && errorFlag) || (!warningFlag && errorFlag)) {
    flagError = 'errorwarning';
  } else if (warningFlag && !errorFlag) {
    flagError = 'warning';
  }
  return { str: flagError, data: errorListData };
};

export const updateControlsButtonTitle = () => {
  const intevalControls = setInterval(() => {
    const element = document.querySelectorAll('.react-flow__controls-button');
    if (element && element.length) {
      clearInterval(intevalControls);
      element.forEach((ele, ind) => {
        ele.setAttribute('data-title', controlsButtonTitle[ind]);
      });
    }
  }, 1);
};

export const streamDataInformation = (stream_no) => {
  let stream_ouput_data = localStorage.getItem('stream_ouput_data');
  let system_units = localStorage.getItem('system-units');
  let unit_set_dict = localStorage.getItem('unit_set_dict');
  let arr = [];
  if (stream_ouput_data && (system_units || unit_set_dict)) {
    stream_ouput_data = JSON.parse(stream_ouput_data)[stream_no];
    system_units = JSON.parse(system_units);
    unit_set_dict = JSON.parse(unit_set_dict);
    const flow = (system_units && system_units.flow) || (unit_set_dict && unit_set_dict['Volume Flow']);
    const pressure = (system_units && system_units.pressure) || (unit_set_dict && unit_set_dict.Pressure);
    arr = [
      { str: 'Stream No', value: Number(stream_no), unitType: '' },
      { str: 'Flow', value: Number(stream_ouput_data.prop_dict.flow).toFixed(4), unitType: flow }, // kranthi flow decimal place increased to 4 from 2
      { str: 'Pressure', value: Number(stream_ouput_data.prop_dict.press).toFixed(2), unitType: pressure },
      { str: 'TDS', value: Number(stream_ouput_data.prop_dict.tds).toFixed(2), unitType: 'mg/l' },
      { str: 'pH', value: Number(stream_ouput_data.prop_dict.ph).toFixed(2), unitType: '' },
      { str: 'Alkalinity', value: Number(stream_ouput_data.prop_dict.malk).toFixed(2), unitType: 'ppm CaCO3' },
    ];
  }
  return arr;
};

const streamHighlitedStart = (str, buttonElement) => {
  if (str === 'empty') {
    buttonElement.current.forEach((ele) => {
      if (ele) {
        ele.style.border = '2px dotted #4b93f4';
        ele.style.borderRadius = '22%';
      }
    });
  }
  else {
    if (str === 'less') {
      buttonElement.current.forEach((ele, ind) => {
        if (ind < 1 && ele) {
          ele.style.border = '2px dotted #4b93f4';
          ele.style.borderRadius = '50%';
        }
      });
    } else {
      buttonElement.current.forEach((ele, ind) => {
        if (ind > 1 && ele) {
          ele.style.border = '2px dotted #4b93f4';
          ele.style.borderRadius = '50%';
        }
      });
    }
  }
};
const streamHighlitedEnd = (buttonElement) => {
  buttonElement.current.forEach((ele) => {
    if (ele) {
      ele.style.border = '';
      ele.style.borderRadius = '';
    }
  });
};
export const streamDataHighlited = (buttonElement, str) => {
  let count = 0;
  streamHighlitedStart(str, buttonElement);
  const highlitedInterval = setInterval(() => {
    if (count > 5) {
      clearInterval(highlitedInterval);
      streamHighlitedEnd(buttonElement);
      return;
    }
    streamHighlitedEnd(buttonElement);
    setTimeout(() => {
      streamHighlitedStart(str, buttonElement);
    }, 500);
    count += 1;
  }, 1000);
};
export const uploadWinFiles = async (event) => {
  const filePromises = ((event) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(event.target.files[0], 'UTF-8');
      reader.onload = (e) => {
        try {
          resolve(e);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  });
  const fileInfos = await filePromises(event);
  return fileInfos;
};

export default decimalFormatter;

// Delete presigned file form s3

// 1. Configure AWS SDK
// AWS.config.update({
//   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
//   secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
//   region: 'us-east-1',
// });

// const s3 = new AWS.S3();

// export const deleteFileFromS3 = async (presignedUrl) => {
//   // try {
//   //   const url = new URL(presignedUrl);
//   //   const bucketName = url.hostname.split('.')[0];
//   //   const key = decodeURIComponent(url.pathname.substr(1));

//   //   const params = {
//   //     Bucket: bucketName,
//   //     Key: key
//   //   };

//   //   await s3.deleteObject(params).promise();
//   //   return true;
//   // } catch (error) {
//   //   console.error('Error deleting file:', error);
//   //   return false;
//   // }

//   return null;
// };